export const GET_CONTRACT_LIST = "GET_CONTRACT_LIST";
export const GET_CONTRACT_LIST_FAILURE = "GET_CONTRACT_LIST_FAILURE";
export const GET_CONTRACT_DETAIL = "GET_CONTRACT_DETAIL";
export const GET_CONTRACT_DETAIL_FAILURE = "GET_CONTRACT_DETAIL_FAILURE";
export const UPDATE_CONTRACT_DETAIL = "UPDATE_CONTRACT_DETAIL";
export const UPDATE_CONTRACT_DETAIL_FAILURE = "UPDATE_CONTRACT_DETAIL_FAILURE";
export const SET_LOADING_CONTRACT = "SET_LOADING_CONTRACT";

